export default "__VITE_PUBLIC_ASSET__c0ca7c6b__"